import { HTTP } from "../helpers/http-common.js";
import axios from "axios";
import config from "../config";
import authHeader from "../helpers/auth-header";
import helpers from "../helpers/helpers";

// Crear instancia de axios sin configuración de Content-Type para FormData
const axiosFormData = axios.create({
  baseURL: config.url_api
});

// Interceptor para ver qué está enviando axios realmente
axiosFormData.interceptors.request.use(config => {
  console.log("🟡 [AXIOS INTERCEPTOR] Request config:", {
    url: config.url,
    method: config.method,
    headers: config.headers,
    data_type: config.data ? config.data.constructor.name : 'null'
  });
  return config;
}, error => {
  return Promise.reject(error);
});

const receptionsService = {
  getDocumentsReception,
  storeDocumentReception,
  getReceptionDetail,
  updateDocumentReception,
  deleteDocumentReception
};

export default receptionsService;

function getDocumentsReception(page = 1, search) {
  let params = "";

  if (search.term) {
    params += `&search=${search.term}`;
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.perPage) {
    params += `&perPage=${search.perPage}`;
  }

  if (search.rangeDates) {
    params += `&range_dates=${search.rangeDates}`;
  }

  return HTTP.get(`get-documents-reception?page=${page}${params}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function getReceptionDetail(id) {
  return HTTP.get(`reception/${id}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function storeDocumentReception(reception = {}) {
  console.log("🔵 [SERVICE] storeDocumentReception - Inicio");
  console.log("🔵 [SERVICE] reception es FormData?", reception instanceof FormData);
  
  // Si es FormData, usar una instancia axios nueva para evitar configuraciones heredadas
  if (reception instanceof FormData) {
    console.log("🔵 [SERVICE] Usando axiosFormData (instancia limpia) para FormData");
    
    const headers = {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    };
    
    console.log("🔵 [SERVICE] URL: /store-document-reception");
    console.log("🔵 [SERVICE] Headers (sin Content-Type):", headers);
    console.log("🔵 [SERVICE] FormData contiene xml_file?", reception.has('xml_file'));
    
    // Usar instancia limpia de axios sin Content-Type
    // axios detectará el FormData y establecerá multipart/form-data automáticamente
    return axiosFormData.post("/store-document-reception", reception, { headers })
      .then(response => {
        console.log("✅ [SERVICE] Respuesta exitosa del backend:", response.data);
        return response;
      })
      .catch(error => {
        console.error("❌ [SERVICE] Error en la petición:", error);
        if (error.response) {
          console.error("❌ [SERVICE] Response status:", error.response.status);
          console.error("❌ [SERVICE] Response data:", error.response.data);
          console.error("❌ [SERVICE] Response headers:", error.response.headers);
        }
        throw error;
      });
  }
  
  // Si no es FormData, usar HTTP wrapper normal con Content-Type JSON
  console.log("🔵 [SERVICE] Usando HTTP wrapper para datos JSON");
  const headers = {
    Authorization: authHeader(),
    "x-Company": helpers.getCompanyId()
  };
  
  return HTTP({
    method: "post",
    url: "store-document-reception",
    data: reception,
    headers: {
      ...headers,
      "Content-Type": "application/json"
    }
  });
}

//JRA Actualizacion de Aceptacion de documentos
function updateDocumentReception(reception = {}) {
  console.log("🟡 [SERVICE] updateDocumentReception - Inicio");
  console.log("🟡 [SERVICE] reception es FormData?", reception instanceof FormData);

  // Si es FormData, usar instancia limpia de axios para evitar corrupción del proxy
  if (reception instanceof FormData) {
    console.log("🟡 [SERVICE] Usando axiosFormData (instancia limpia) para FormData");

    const headers = {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
      // NO incluir Content-Type - axios lo detectará automáticamente
    };

    console.log("🟡 [SERVICE] URL: /update-document-reception");
    console.log("🟡 [SERVICE] Headers (sin Content-Type):", headers);
    console.log("🟡 [SERVICE] FormData entries:");
    for (let pair of reception.entries()) {
      console.log(`  ${pair[0]}:`, pair[1]);
    }

    // Usar instancia limpia de axios sin Content-Type
    return axiosFormData.post("/update-document-reception", reception, { headers })
      .then(response => {
        console.log("✅ [SERVICE] Respuesta exitosa del backend:", response.data);
        return response;
      })
      .catch(error => {
        console.error("❌ [SERVICE] Error en la petición:", error);
        if (error.response) {
          console.error("❌ [SERVICE] Response status:", error.response.status);
          console.error("❌ [SERVICE] Response data:", error.response.data);
          console.error("❌ [SERVICE] Response headers:", error.response.headers);
        }
        throw error;
      });
  }

  // Si no es FormData, usar HTTP wrapper normal
  console.log("🟡 [SERVICE] Usando HTTP wrapper para datos no-FormData");
  return HTTP({
    method: "post",
    url: "update-document-reception",
    data: reception,
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

//Delete Document Reception
function deleteDocumentReception(id) {
  return HTTP({
    method: "delete",
    url: `delete-document-reception/${id}`,
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}
